import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

export const isNumber = (value: unknown): value is number => typeof value === "number";
export const isArray = (value: unknown): value is unknown[] => Array.isArray(value);
export const isObject = (value: unknown): value is Record<string, unknown> => typeof value === "object" && value !== null && !isArray(value);
export const isFunction = (p: unknown): p is (...args: never[]) => never => typeof p === "function";
export const isPayloadErrorWithMessage = (payload: unknown): payload is FetchBaseQueryError & { data: { message: string } } =>
  isObject(payload) && "data" in payload && isObject(payload.data) && "message" in payload.data && typeof payload.data.message === "string";

export const isStatusCode = (payload: unknown, status: number): payload is FetchBaseQueryError => isObject(payload) && isNumber(payload.status) && payload.status === status;
